import { z } from 'zod';
export const toPatchSchema = (schema) => {
    const shape = {};
    for (const [key, field] of Object.entries(schema.shape)) {
        /* Ein Feld mit Vorgabewert umschließt das eigentliche Schema als `innerType`. */
        const inner = field.def?.innerType;
        shape[key] = inner ?? field;
    }
    /*
     * Der Aufbau geschieht zur Laufzeit über die Shape; TypeScript kann die Zuordnung
     * nicht mitverfolgen. `PatchShape<T>` beschreibt das Ergebnis genau, weshalb die
     * Behauptung hier trägt.
     */
    return z.object(shape).partial();
};
//# sourceMappingURL=patch.js.map